import { render, staticRenderFns } from "./ota-detail-list.vue?vue&type=template&id=4c66cb7a&scoped=true&"
import script from "./ota-detail-list.vue?vue&type=script&lang=ts&"
export * from "./ota-detail-list.vue?vue&type=script&lang=ts&"
import style0 from "./ota-detail-list.vue?vue&type=style&index=0&id=4c66cb7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66cb7a",
  null
  
)

export default component.exports